import { AppShell, MantineProvider, useMantineTheme } from '@mantine/core';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import {
  Checklist,
  Devices,
  FileReport,
  Forms,
  History,
  Home,
  LetterB,
  LetterM,
  LetterP,
  LetterR,
  Link,

  ReportMoney,

  ReceiptRefund,

  Users,
} from 'tabler-icons-react';
import { Roles } from '../../enums/roles-enum';
import useAuth from '../../hooks/useAuth';
import { NavLinkType } from '../../type/navlink.types';
import AppHeader from './header/header.component';
import AppSidebar from './sidebar/sidebar.component';

const AdminDashboardLayout = () => {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);

  const { auth } = useAuth();

  // for settlement and admin role only
  let navLinkProps: NavLinkType[] = [];

  // for admin role only

  if (auth?.role === Roles.ADMINISTRATOR) {
    navLinkProps = [
      {
        order: 1,
        link: '/admin',
        label: 'Dashboard',
        icon: Home,
      },
      {
        order: 2,
        link: '/admin/onboarding',
        label: 'Onboarding',
        icon: Checklist,
      },
      {
        order: 3,
        link: '/admin/partners',
        label: 'Partners',
        icon: LetterP,
      },
      {
        order: 4,
        link: '/admin/resellers',
        label: 'Resellers',
        icon: LetterR,
      },
      {
        order: 5,
        link: '/admin/merchants',
        label: 'Merchants',
        icon: LetterM,
      },
      {
        order: 6,
        link: '/admin/branches',
        label: 'Branches',
        icon: LetterB,
      },
      {
        order: 7,
        link: '/admin/create-payment-links',
        label: 'Payment Links',
        icon: Link,
      },
      {
        order: 8,
        link: '/admin/settlements',
        label: 'Settlements',
        icon: ReportMoney,
      },
      {
        order: 9,
        link: '/admin/transactions',
        label: 'Transactions',
        icon: FileReport,
      },

      {

        order: 10,
        link: '/admin/refund',
        label: 'Refund Approval',
        icon: ReceiptRefund,
      },

      {

        order: 11,
        link: '/admin/logs',
        label: 'Logs',
        icon: History,
      },
      {
        order: 12,
        link: 'admin/users',
        label: 'User Management',

        icon: Users,
      },
      {
        order: 13,
        sublinks: [
          { link: 'admin/mids', label: 'View All MIDs' },
          { link: '/admin/mids/add', label: 'Create MID' },
        ],
        link: '',
        label: 'MID',
        icon: Forms,
      },
      {
        order: 14,
        sublinks: [
          { link: 'admin/pos', label: 'View All POSs' },
          {
            link: '/admin/pos/create',
            label: 'Create POS',
          },
        ],
        link: '',
        label: 'POS',
        icon: Devices,
      },
      
    ];
  }

  const repositionLinks = () => {
    return navLinkProps.sort((a, b) => {
      return a.order - b.order;
    });
  };

  return (
    <MantineProvider withGlobalStyles withNormalizeCSS>
      <AppShell
        styles={{
          main: {
            background:
              theme.colorScheme === 'dark' ? theme.colors.dark[8] : '#ffffff',
            '@media (max-width: 992px)': {
              paddingLeft: 'calc(var(--mantine-aside-width, 0px) + 16px)',
            },
          },
        }}
        navbarOffsetBreakpoint='md'
        asideOffsetBreakpoint='md'
        fixed
        navbar={<AppSidebar navLinkProps={repositionLinks()} opened={opened} />}
        header={<AppHeader opened={opened} setOpened={setOpened} />}
      >
        <Outlet />
      </AppShell>
    </MantineProvider>
  );
};

export default AdminDashboardLayout;
